export const navLinks = [
  { href: "/", label: "Home" },
  { href: "/about-us", label: "About" },
  { href: "/catalogues", label: "Catalogues" },
  { href: "/products", label: "Products" },
  { href: "/contact", label: "Contact" },
];